import {MediaTypeEnum} from "../../../enums/index";
import { BaseSearchDTO } from "../API";
import {BaseIntDTO} from "../_baseIntDTO.interface";

export interface CustomerDocumentCategoryDTO extends BaseIntDTO {

  documentCategoryName: string;
  mediaType: MediaTypeEnum;
}
